import "../assets/index-5c74e333.css";
import { t as r } from "../chunks/l10n-ef44019c.mjs";
import c from "./NcTimezonePicker.mjs";
import u from "./NcPopover.mjs";
import { l as p } from "../chunks/l10n-c603e589.mjs";
import { n as l } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
import { getMonthNames as m, getMonthNamesShort as d, getDayNames as f, getDayNamesShort as _, getDayNamesMin as h, getFirstDay as v } from "@nextcloud/l10n";
import y from "vue2-datepicker";
import { S as g } from "../chunks/ScopeComponent-3ea00dcd.mjs";
const k = {
  name: "CalendarBlankIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var C = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon calendar-blank-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(a) {
    return e.$emit("click", a);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, w = [], z = /* @__PURE__ */ l(
  k,
  C,
  w,
  !1,
  null,
  null,
  null,
  null
);
const M = z.exports, b = {
  name: "WebIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var P = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon web-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(a) {
    return e.$emit("click", a);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, S = [], D = /* @__PURE__ */ l(
  b,
  P,
  S,
  !1,
  null,
  null,
  null,
  null
);
const T = D.exports;
const i = {
  date: "YYYY-MM-DD",
  datetime: "YYYY-MM-DD H:mm:ss",
  year: "YYYY",
  month: "YYYY-MM",
  time: "H:mm:ss",
  week: "w"
}, $ = {
  name: "NcDateTimePicker",
  components: {
    CalendarBlank: M,
    DatePicker: y,
    NcPopover: u,
    NcTimezonePicker: c,
    Web: T
  },
  mixins: [p],
  inheritAttrs: !1,
  props: {
    clearable: {
      type: Boolean,
      default: !1
    },
    minuteStep: {
      type: Number,
      default: 10
    },
    type: {
      type: String,
      default: "date"
    },
    format: {
      type: String,
      default: null
    },
    formatter: {
      type: Object,
      default: null
    },
    lang: {
      type: Object,
      default: null
    },
    /**
     * The value to initialize, but also two-way bind the selected date. The date is – like the `Date` object in
     * JavaScript – tied to UTC. The selected time zone does not have an influence of the selected time and date
     * value. You have to translate the time yourself when you want to factor in time zones.
     */
    // eslint-disable-next-line
    value: {
      default: () => /* @__PURE__ */ new Date()
    },
    /**
     * The preselected IANA time zone ID for the time zone picker, only relevant in combination with `:show-timezone-select="true"`. Example: `Europe/Berlin`. The prop supports two-way binding through the .sync modifier.
     */
    timezoneId: {
      type: String,
      default: "UTC"
    },
    showTimezoneSelect: {
      type: Boolean,
      default: !1
    },
    highlightTimezone: {
      type: Boolean,
      default: !1
    },
    appendToBody: {
      type: Boolean,
      default: !1
    },
    showWeekNumber: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  emits: [
    "update:value",
    "update:timezone-id"
  ],
  data() {
    return {
      showTimezonePopover: !1,
      tzVal: this.timezoneId
    };
  },
  computed: {
    /**
     * Datepicker language
     * https://github.com/mengxiong10/vue2-datepicker/blob/master/locale.md
     *
     * @return {object}
     */
    defaultLang() {
      return {
        formatLocale: {
          months: m(),
          monthsShort: d(),
          weekdays: f(),
          weekdaysShort: _(),
          weekdaysMin: h(),
          // 0 = sunday, 1 = monday
          firstDayOfWeek: v()
        },
        monthFormat: "MMM"
      };
    },
    /**
     * Translated placeholder
     *
     * @return {string}
     */
    defaultPlaceholder() {
      return this.type === "time" ? r("Pick a time") : this.type === "month" ? r("Pick a month") : this.type === "year" ? r("Pick a year") : this.type === "week" ? r("Pick a week") : this.type === "date" ? r("Pick a date") : r("Pick a date and a time");
    },
    /**
     * If format is not provided, try to match the type
     * or fallback to 'date'
     *
     * @return {string}
     */
    formatTypeMap() {
      var n;
      return (n = i[this.type]) != null ? n : i.date;
    }
  },
  methods: {
    handleSelectYear(n) {
      const e = this.$refs.datepicker.currentValue;
      if (e)
        try {
          const t = new Date(new Date(e).setFullYear(n));
          this.$refs.datepicker.selectDate(t);
        } catch {
          console.error("Invalid value", e, n);
        }
    },
    handleSelectMonth(n) {
      const e = this.$refs.datepicker.currentValue;
      if (e)
        try {
          const t = new Date(new Date(e).setMonth(n));
          this.$refs.datepicker.selectDate(t);
        } catch {
          console.error("Invalid value", e, n);
        }
    },
    /**
     * Toggles the visibility of the time zone popover
     */
    toggleTimezonePopover() {
      this.showTimezoneSelect && (this.showTimezonePopover = !this.showTimezonePopover);
    }
  }
};
var H = function() {
  var e = this, t = e._self._c;
  return t("DatePicker", e._g(e._b({ ref: "datepicker", attrs: { "append-to-body": e.appendToBody, clearable: e.clearable, format: e.format ? e.format : e.formatTypeMap, formatter: e.formatter, lang: e.lang ? e.lang : e.defaultLang, "minute-step": e.minuteStep, placeholder: e.placeholder ? e.placeholder : e.defaultPlaceholder, "popup-class": { "show-week-number": e.showWeekNumber }, "show-week-number": e.showWeekNumber, type: e.type, value: e.value }, on: { "select-year": e.handleSelectYear, "select-month": e.handleSelectMonth, "update:value": function(a) {
    return e.$emit("update:value", e.value);
  } }, scopedSlots: e._u([{ key: "icon-calendar", fn: function() {
    return [e.showTimezoneSelect ? t("NcPopover", { attrs: { shown: e.showTimezonePopover, "popover-base-class": "timezone-select__popper" }, on: { "update:shown": function(a) {
      e.showTimezonePopover = a;
    } }, scopedSlots: e._u([{ key: "trigger", fn: function() {
      return [t("button", { staticClass: "datetime-picker-inline-icon", class: { "datetime-picker-inline-icon--highlighted": e.highlightTimezone }, on: { mousedown: function(a) {
        return a.stopPropagation(), a.preventDefault(), (() => {
        }).apply(null, arguments);
      } } }, [t("Web", { attrs: { size: 20 } })], 1)];
    }, proxy: !0 }], null, !1, 3375037618) }, [t("div", { staticClass: "timezone-popover-wrapper__label" }, [t("strong", [e._v(" " + e._s(e.t("Please select a time zone:")) + " ")])]), t("NcTimezonePicker", { staticClass: "timezone-popover-wrapper__timezone-select", on: { input: function(a) {
      return e.$emit("update:timezone-id", arguments[0]);
    } }, model: { value: e.tzVal, callback: function(a) {
      e.tzVal = a;
    }, expression: "tzVal" } })], 1) : t("CalendarBlank", { attrs: { size: 20 } })];
  }, proxy: !0 }, e._l(e.$scopedSlots, function(a, o) {
    return { key: o, fn: function(s) {
      return [e._t(o, null, null, s)];
    } };
  })], null, !0) }, "DatePicker", e.$attrs, !1), e.$listeners));
}, N = [], Y = /* @__PURE__ */ l(
  $,
  H,
  N,
  !1,
  null,
  "26676d3b",
  null,
  null
);
const x = Y.exports;
/**
 * @copyright Copyright (c) 2018 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
g(x);
export {
  x as default
};
